import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-track",
  "use": "icon-track-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-track\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" /> \n\t<path d=\"M5,15v4H9V15ZM5,5V9H9V5ZM15,5V9h4V5Zm1,11V13h2v3h3v2H18v3H16V18H13V16ZM13,3h8v8H13ZM3,13h8v8H3ZM3,3h8v8H3Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol